const platformUids = {
    D4Sign: '7d9b3b1d-61f7-4e7f-b5d7-8b44c5d39b9d',
    DocuSign: '47ee0948-af4b-4308-9f31-c6f2116939f1',
    DocuSignDemo: 'd248550c-f94f-42d8-9252-2863b6b2d570'
};

export default platformUids